export enum AlertTypeEnum {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}
